/* eslint-disable @typescript-eslint/no-explicit-any */
import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFetchBaseQuery } from "@/redux/apiFetchBaseQuery";

interface ImpersonationStartResponse {
	success: boolean;
	message: string;
	[key: string]: any;
}

interface ImpersonationEndResponse {
	success: boolean;
	message: string;
	[key: string]: any;
}

export const impersonationSlice = createApi({
	reducerPath: "impersonationSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["impersonation"],
	endpoints: builder => ({
		startImpersonation: builder.mutation<ImpersonationStartResponse, { userId: number }>({
			query: ({ userId }) => ({
				url: "/admin/impersonate/start",
				method: "POST",
				body: new URLSearchParams({
					user_id: userId.toString(),
				}),
				headers: {
					"Content-Type": "application/x-www-form-urlencoded",
					accept: "application/json",
				},
			}),
			invalidatesTags: ["impersonation"],
		}),

		endImpersonation: builder.mutation<ImpersonationEndResponse, void>({
			query: () => ({
				url: "/admin/impersonate/stop",
				method: "POST",
				headers: {
					accept: "application/json",
				},
			}),
			invalidatesTags: ["impersonation"],
		}),
	}),
});

export const { useStartImpersonationMutation, useEndImpersonationMutation } = impersonationSlice;
